module.exports = new __parcel__URL__("logo.54569a80.svg").toString();